import get from "lodash/get";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import classNames from "classnames";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../../Actions/AxiosInstance";
import {
  ValidateList,
  ValidateReqField,
  ValidateReqFields,
  ValidateSearchDropdown,
  ValidateDropdown,
  ValidateAction,
} from "../../../../Utils/Validation";
import { CustomForm } from "../../../../Assets/Js/CustomForm";
import createstore from "../../../../store";
import { refreshProfileInfo } from "../../../../Actions/commonAction";

import If from "../../../../Component/Common/If";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
});

class EmpAbout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        firstname: "",
        middlename: "",
        lastname: "",
        preferredname: "",
        aboutyourself: "",
      },
      reqFields: {
        firstname: "",
        aboutyourself: "",
      },
      list: {
        salutationid: "",
      },
      reqList: {
        salutationid: "",
      },
      errors: {},
      helperText: {},
      salutationList: [],
      placeholder: "text",
      hideButton: false,
      data: {},
      viewpage: true,
      dataReceived: false,
    };

    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {
    if (this.firstElement) this.firstElement.focus();
  }

  componentWillMount() {
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    let { employeeid } = SubscriptionInfo.SubscriptionData;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;
    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    let hideButton;
    permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        colleagueid,
        hideButton,
      },
      () => {
        this.GetProfileBasicInfo();
      },
    );
  }

  UpdateSelectedDropdownItem(name, selectedName, selectedItem) {
    const { list } = this.state;
    const { reqList } = this.state;
    // list[name] = selectedItem;
    list[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";
    // [selectedName] = selectedItem ? selectedItem : ''
    this.setState({ list, [selectedName]: selectedItem });

    if (reqList[name] == "" || reqList[name] || reqList[name] == null) {
      reqList[name] = selectedItem.displayvalue
        ? selectedItem.displayvalue
        : "";
      this.setState({ reqList });
      ValidateDropdown(this.state, name);
      this.setState({ reqList }, () => {
        this.ValidateEachDropDown(name);
      });
    }
  }

  ValidateEachDropDown(name) {
    ValidateSearchDropdown(this.state, name).then((result) => {
      this.setState({
        errors: result.errors,
      });
    });
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    this.setState({ fields }, () => {
      ValidateAction(this.state, field, type);
    });
  }

  ValidateField(reqField, type, e) {
    console.log("TCL: ValidateField -> e", e);
    console.log("TCL: ValidateField -> type", type);
    console.log("TCL: ValidateField -> reqField", reqField);

    const { reqFields } = this.state;
    reqFields[reqField] = e.target.value ? e.target.value : "";
    reqFields[reqField] = e.target.value;
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  ValidateOnNext(reqField, type) {
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  GetProfileBasicInfo() {
    const URL = "/employee/empaboutme";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        let data = {};
        result.data.result.length > 0
          ? (data = result.data.result[0])
          : (data = {});
        const fields = {
          firstname: data.firstname ? data.firstname : "",
          middlename: data.middlename,
          lastname: data.lastname,
          preferredname: data.preferredname,
          aboutyourself: data.aboutyourself ? data.aboutyourself : "",
        };
        const reqFields = {
          firstname: data.firstname ? data.firstname : "",
          aboutyourself: data.aboutyourself ? data.aboutyourself : "",
        };
        const list = {
          salutationid: data.salutationid,
        };
        const reqList = {
          salutationid: data.salutationid,
        };
        let selectedSalutation;
        instance
          .get("superuser/getmastercode/SalutationType")
          .then((result) => {
            const salutationList = [];
            salutationList.push(
              { displayname: "Select Salutation", displayvalue: "" },
              ...result.data.result,
            );
            selectedSalutation = salutationList.find(
              (x) => x.displayvalue == data.salutationid,
            );
            this.setState({ salutationList, selectedSalutation });
          })
          .catch((error) => {
            const CommonError = error.response
              ? error.response.data.error.message
              : error.message;
            this.props.enqueueSnackbar(CommonError, { variant: "error" });
          });

        this.setState({
          fields,
          reqFields,
          list,
          reqList,
          data,
          dataReceived: true,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  Validate() {
    let formIsValid = true;

    if (!ValidateList(this.state)) {
      formIsValid = false;
    }
    if (!ValidateReqFields(this.state)) {
      formIsValid = false;
    }
    return formIsValid;
  }

  getEditMode() {
    this.setState(
      {
        viewpage: false,
      },
      () => {
        if (this.firstElement) this.firstElement.focus();
      },
    );
  }

  refNext(name, e) {
    if (name && e.keyCode === 13) {
      switch (name) {
        case "salutationid":
          this.firstname.focus();
          break;

        case "firstname":
          this.middlename.focus();
          break;
      }
    }
  }

  UpdatePersonalDetails() {
    if (
      this.state.errors.firstname == true ||
      this.state.errors.lastname == true ||
      this.state.errors.salutationid == true
    ) {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else {
      const data = {
        salutationid: this.state.list.salutationid,
        firstname: this.state.fields.firstname,
        middlename: this.state.fields.middlename,
        lastname: this.state.fields.lastname,
        preferredname: this.state.fields.preferredname,
        aboutyourself: this.state.fields.aboutyourself,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
      if (!createstore.getState().AuthenticationAction.IsFulfilled) {
        Object.assign(data, {
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
          employeeid: this.props.colleagueid || this.state.employeeid,
        });
      }

      instance
        .post("employee/insertupdateempaboutme", data)
        .then((result) => {
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          this.setState({
            viewpage: true,
          });
          this.props.refreshProfileInfo(true);
          this.props.UpdateStrength(true);
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return false;
      }
    }

    return true;
  }

  onCancel() {
    const { fields } = this.state;
    fields.firstname = this.state.data.firstname;
    this.setState({
      viewpage: true,
      fields,
    });
  }

  showComp = (value) => <div className="address-data">{value || "-"}</div>;
  // {
  //   this.state.salutionList&&this.state.salutationList.map(item=>{
  //     if(item.displayvalue==value){
  //        return <div className="address-data">{item.displayname ? item.displayname : " "}</div>
  //     }
  //   })

  //   }
  showSalutationComp = (value) => {
    let salution = "";
    this.state.salutationList &&
      this.state.salutationList.forEach((item) => {
        if (item.displayvalue == value) {
          salution = item.displayname;
        }
      });
    return <div className="address-data">{salution || "-"}</div>;
  };

  render() {
    const { dataReceived, viewpage, hideButton, selectedSalutation } =
      this.state;
    const { classes } = this.props;
    return (
      <div>
        {/* <If condition={hideButton}>
          <div>No records found</div>
        </If> */}
        <If condition={dataReceived}>
          <div>
            <svg
              className={
                !viewpage || hideButton ? "hide-button" : "biodata-edit-btn"
              }
              onClick={this.getEditMode.bind(this)}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style={{ zIndex: 10 }}
            >
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
            </svg>
            <div className="emp-from-wrapper imp-dates">
              <div className="form-height">
                <div id="div">
                  <form
                    className="custom-form-box profile-about"
                    autoComplete="off"
                  >
                    <div className="inner-wrapper opaque" tabIndex="0">
                      <div className="form-group">
                        <p className="input-form-label">
                          <span className="emp-special-head">
                            <FormattedMessage
                              id="LbSalutation"
                              defaultMessage="Salutation"
                            />
                          </span>
                        </p>
                        {viewpage ? (
                          get(
                            this.state,
                            "selectedSalutation.displayvalue",
                            "-",
                          ) &&
                          this.showSalutationComp(
                            get(
                              this.state,
                              "selectedSalutation.displayvalue",
                              "-",
                            ),
                          )
                        ) : (
                          <div className="margin-left-1">
                            <Select
                              ref={(r) => {
                                this.firstElement = r;
                              }}
                              className="selectsearch"
                              onChange={this.UpdateSelectedDropdownItem.bind(
                                this,
                                "salutationid",
                                "selectedSalutation",
                              )}
                              options={this.state.salutationList}
                              getOptionLabel={(option) => option.displayname}
                              getOptionValue={(option) => option.displayvalue}
                              value={this.state.selectedSalutation}
                              placeholder="Salutation"
                            />
                            <div>
                              {this.state.errors.salutationid ? (
                                <span className="caption-error">
                                  <FormattedMessage
                                    id="ErSalutation"
                                    defaultMessage="Please Select Salutation"
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="1">
                      <div className="form-group">
                        <p className="input-form-label">
                          <FormattedMessage
                            id="LbFirstName"
                            defaultMessage="First Name"
                          />
                        </p>
                        {viewpage ? (
                          this.showComp(this.state.fields.firstname)
                        ) : (
                          <div>
                            <TextField
                              id="firstname"
                              className={classNames(
                                classes.textField,
                                classes.dense,
                              )}
                              margin="dense"
                              variant="outlined"
                              // onFocus={this.SetHelperTextFlag.bind(this, "firstname", "Htfirstname")}
                              onChange={this.OnFieldChange.bind(
                                this,
                                "firstname",
                                "name",
                              )}
                              onBlur={this.ValidateField.bind(
                                this,
                                "firstname",
                                "name",
                              )}
                              value={this.state.fields.firstname}
                              maxLength="50"
                            />

                            <div>
                              {this.state.errors.firstname ? (
                                <span className="caption-error">
                                  <FormattedMessage
                                    id="ErFirstName"
                                    defaultMessage="can not be empty"
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="2">
                      <div className="form-group">
                        <p className="input-form-label">
                          <FormattedMessage
                            id="__LbMiddleName"
                            defaultMessage="Middle Name (Optional)"
                          />{" "}
                        </p>
                        {viewpage ? (
                          this.showComp(this.state.fields.middlename)
                        ) : (
                          <div>
                            <TextField
                              id="middlename"
                              className={classNames(
                                classes.textField,
                                classes.dense,
                              )}
                              margin="dense"
                              variant="outlined"
                              autocomplete="off"
                              autofocus
                              // onFocus={this.SetHelperTextFlag.bind(this, "middlename", "Htmiddlename")}
                              onChange={this.OnFieldChange.bind(
                                this,
                                "middlename",
                                "name",
                              )}
                              // onBlur={this.ValidateField.bind(this, "middlename", "name")}
                              value={this.state.fields.middlename}
                              maxLength="50"
                            />
                            <div>
                              {this.state.errors.middlename ? (
                                <span className="caption-error">
                                  <FormattedMessage
                                    id="ErMiddleName"
                                    defaultMessage="can not be empty"
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="3">
                      <div className="form-group">
                        <p className="input-form-label">
                          <FormattedMessage
                            id="LbLastName"
                            defaultMessage="Last Name"
                          />{" "}
                        </p>
                        {viewpage ? (
                          this.showComp(this.state.fields.lastname)
                        ) : (
                          <div>
                            <TextField
                              id="lastname"
                              className={classNames(
                                classes.textField,
                                classes.dense,
                              )}
                              margin="dense"
                              variant="outlined"
                              autocomplete="off"
                              autofocus
                              placeholder="Last Name"
                              // onFocus={this.SetHelperTextFlag.bind(this, "lastname", "Htlastname")}
                              onChange={this.OnFieldChange.bind(
                                this,
                                "lastname",
                                "name",
                              )}
                              onBlur={this.ValidateField.bind(
                                this,
                                "lastname",
                                "name",
                              )}
                              value={this.state.fields.lastname}
                              maxLength="50"
                            />
                            <div>
                              {this.state.errors.lastname ? (
                                <span className="caption-error">
                                  <FormattedMessage
                                    id="ErLastName"
                                    defaultMessage="can not be empty"
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="4">
                      <div className="form-group">
                        <p className="input-form-label">
                          <FormattedMessage
                            id="LbPreferredName__"
                            defaultMessage="Preferred Name (Optional)"
                          />{" "}
                        </p>
                        {viewpage ? (
                          this.showComp(this.state.fields.preferredname)
                        ) : (
                          <div>
                            <TextField
                              id="preferredname"
                              className={classNames(
                                classes.textField,
                                classes.dense,
                              )}
                              margin="dense"
                              variant="outlined"
                              autocomplete="off"
                              autofocus
                              placeholder="Preferred Name"
                              // onFocus={this.SetHelperTextFlag.bind(this, "preferredname", "Htpreferredname")}
                              onChange={this.OnFieldChange.bind(
                                this,
                                "preferredname",
                                "name",
                              )}
                              // onBlur={this.ValidateField.bind(this, "preferredname", "name")}
                              value={this.state.fields.preferredname}
                              maxLength="50"
                            />
                            <div>
                              {this.state.errors.preferredname ? (
                                <span className="caption-error">
                                  <FormattedMessage
                                    id="ErPreferredName"
                                    defaultMessage="can not be empty"
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="5">
                      <div className="form-group">
                        <p className="input-form-label">
                          <FormattedMessage
                            id="__LbAboutYourself"
                            defaultMessage="About Yourself (Optional)"
                          />{" "}
                        </p>
                        {viewpage ? (
                          this.showComp(this.state.fields.aboutyourself)
                        ) : (
                          <div>
                            <textarea
                              className="input-area-section"
                              placeholder="About Yourself"
                              // onFocus={this.SetHelperTextFlag.bind(this, "aboutyourself", "aboutyourself")}
                              onChange={this.OnFieldChange.bind(
                                this,
                                "aboutyourself",
                                "text",
                              )}
                              // onBlur={this.ValidateField.bind(this, "aboutyourself", "text")}
                              value={this.state.fields.aboutyourself}
                              maxLength="255"
                            />
                            {/* <div>
                              {!!this.state.errors["aboutyourself"] ? (
                                <span className="caption-error">
                                  <FormattedMessage
                                    id="ErAboutYourself"
                                    defaultMessage="can not be empty"
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                            </div> */}
                          </div>
                        )}
                      </div>
                    </div>
                    {!viewpage && (
                      <div className="upform-footer">
                        <Button
                          className="form-btn form-control"
                          variant="contained"
                          color="primary"
                          size="large"
                          onClick={this.UpdatePersonalDetails.bind(this)}
                        >
                          <FormattedMessage id="BtSave" defaultMessage="Save" />
                        </Button>
                        <span tabIndex="6" className="margin-left-16 ">
                          <Button
                            size="large"
                            onClick={this.onCancel}
                            className="cancel"
                          >
                            <span>
                              <FormattedMessage
                                id="BtCancel"
                                defaultMessage="Cancel"
                              />
                            </span>
                          </Button>
                        </span>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </If>
      </div>
    );
  }
}

EmpAbout.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      refreshProfileInfo: (data) => refreshProfileInfo(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(EmpAbout)));
